const lowercaseWords = new Set(['and', 'of', 'the']);
const apostropheFixes = [
  [/\bprince georges\b/g, "prince george's"],
  [/\bqueen annes\b/g, "queen anne's"],
  [/\bst marys\b/g, "st mary's"],
  [/\bo ?brien\b/g, "o'brien"]
];

/**
 * Title-cases a single place name word
 *
 * @param {string} word - lowercase word
 * @param {number} index - position in the place name
 * @returns {string}
 */
const formatPlaceWord = (word, index) => {
  if (word === 'st' || word === 'saint') {
    return 'St.';
  }

  if (word === 'ste') {
    return 'Ste.';
  }

  if (index > 0 && lowercaseWords.has(word)) {
    return word;
  }

  return word
    .replace(/(^|-)([a-z])/g, match => match.toUpperCase())
    .replace(/'([a-z])(?=[a-z])/g, match => match.toUpperCase())
    .replace(/^Mc([a-z])/, match => `Mc${match.charAt(2).toUpperCase()}`);
};

/**
 * Title-cases a US place name, keeping the forms people expect, e.g. `St. Louis`, `McHenry`, `Prince George's`
 *
 * @param {object} opts
 * @param {string} [opts.text] - lowercase place name with words separated by spaces, e.g. `st louis`
 * @returns {string} empty when the text is missing
 * @example formatPlaceName({ text: 'mchenry county' }) // 'McHenry County'
 */
const formatPlaceName = (opts = {}) => {
  if (typeof opts.text !== 'string') {
    return '';
  }

  let text = opts.text
    .trim()
    .toLowerCase()
    .replace(/\s+/g, ' ');

  apostropheFixes.forEach(([pattern, replacement]) => {
    text = text.replace(pattern, replacement);
  });

  return text
    .split(' ')
    .map(formatPlaceWord)
    .join(' ');
};

export default formatPlaceName;
